import bg1 from 'assets/pictures/background/bg1.jpg'
import bg2 from 'assets/pictures/background/bg2.jpeg'
import bg3 from 'assets/pictures/background/bg3.jpeg'
import bg4 from 'assets/pictures/background/bg4.jpeg'
import { push } from '@lagunovsky/redux-react-router'
import { template } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { contentsPath } from '../../conf/basepath'
import { applicationName, aquasysPath } from '../../conf/SieauConstants'
import aquasysLogoPath from 'assets/pictures/logoaQuasys.png'
import HomeAction from '../actions/HomeAction'
import { NAME_LOGIN_PICTURE } from 'administration/constants/AdministrationConstants'
import { useLocation } from 'react-router'
import { Button, Grid, Card, CardContent, Stack, Typography } from '@mui/material'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import InputLogin from 'components/forms/InputLogin'

const ResetPasswordApp = () => {
    const dispatch = useDispatch()

    const location = useLocation()
    const token = new URLSearchParams(location.search).get('token')

    const backgroundPicture = useApplicationSetting(NAME_LOGIN_PICTURE)
    const passwordPolicy = useApplicationSetting('passwordPolicy')
    const logoSetting = useApplicationSetting('applicationLogoConnexion')
    const applicationTitle = useApplicationSetting('applicationTitle')
    const securityPasswordDescription = useApplicationSetting('securityPasswordDescription')
    const applicationFavicon = useApplicationSetting('applicationFavicon')
    const applicationNameSetting = useApplicationSetting('applicationName')
    const version = useApplicationSetting('applicatioversionnName')

    const [clicked, setClicked] = useState(false)
    const [login, setLogin] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [newPasswordAgain, setNewPasswordAgain] = useState('')
    const [defaultBackground, setDefaultBackground] = useState(false)
    const [logo, setLogo] = useState()

    useEffect(() => {
        if (backgroundPicture) {
            const backgroundUrl = `${contentsPath}_PUBLIC/${backgroundPicture}`
            dispatch(HomeAction.checkImageExists(backgroundUrl)).then((found) => {
                if (found) {
                    document.body.classList.add('login-body')
                    document.querySelector('.login-body').style.backgroundImage = `url('${backgroundUrl}')`
                } else {
                    setDefaultBackground(true)
                }
            })
        }
    }, [backgroundPicture])


    useEffect(() => {
        return () => {
            if (document.querySelector('.login-body')) {
                document.querySelector('.login-body').style.backgroundImage = ''
            }
            document.body.classList.remove('login-body')
        }
    }, [])

    const onValidatingPassword = () => {
        const regex = new RegExp(passwordPolicy)
        if (newPassword !== newPasswordAgain) {
            dispatch(ToastrAction.error(i18n.confirmPasswordError))
        } else if (!regex.test(newPassword)) {
            dispatch(ToastrAction.error(i18n.passwordPolicyError))
        } else {
            dispatch(HomeAction.updatePassword(newPassword, token))
        }
    }

    useEffect(() => {
        if (logoSetting) {
            dispatch(HomeAction.checkImageExists(logoSetting)).then(exists => {
                if (exists) {
                    setLogo(
                        (<img
                            src={ logoSetting }
                            alt='logo SIEau'
                            className='responsive-img'
                        />),
                    )
                }
            })
        }
    }, [logoSetting])

    const onSubmit = () => {
        setClicked(true)
        dispatch(HomeAction.resetPassword(login))
    }

    const getPanel = () => {
        if (token) {
            return (
                <>
                    { logo || applicationTitle && <h4> { applicationTitle || '' } </h4> }
                    <Grid sx={{ width: '100%' }}>
                        { securityPasswordDescription }
                    </Grid>
                    <Grid sx={{ width: '100%' }}>
                        <InputLogin
                            label={i18n.newPassword}
                            iconLabel='lock'
                            passwordInput
                            value={newPassword}
                            onChange={setNewPassword}
                            onEnterKeyPress={onValidatingPassword}
                            required
                        />
                    </Grid>
                    <Grid sx={{ width: '100%' }}>
                        <InputLogin
                            label={i18n.newPasswordAgain}
                            iconLabel='lock'
                            passwordInput
                            value={newPasswordAgain}
                            onChange={setNewPasswordAgain}
                            onEnterKeyPress={onValidatingPassword}
                            required
                        />
                    </Grid>
                    <Button
                        variant='contained'
                        onClick={onValidatingPassword}
                    >
                        { i18n.validate }
                    </Button>
                </>
            )
        }


        return (
            <>
                { logo }
                <h5>{ i18n.forgetPassword }</h5>
                { i18n.forgetPasswordText }
                <Grid sx={{ width: '100%' }}>
                    <InputLogin
                        label={i18n.login}
                        iconLabel='person'
                        value={login}
                        onChange={setLogin}
                        onEnterKeyPress={onSubmit}
                        required
                    />
                </Grid>
                <Button
                    disabled={clicked}
                    onClick={onSubmit}
                    variant='contained'
                >
                    { i18n.retrievePassword }
                </Button>
                <Button
                    onClick={() => dispatch(push('/login')) }
                    variant='contained'
                >
                    { i18n.toLogin }
                </Button>
            </>
        )
    }

    $(document).ready(() => {
        $('.slider').slider({
            indicators: false,
        })
    })

    const slider = useMemo(() => {
        return defaultBackground ? (
            <div className='slider fullscreen'>
                <ul className='slides'>
                    { [bg1, bg2, bg3, bg4].map(b => {
                        return (
                            <li key={b}>
                                <img src={ b } />
                            </li>
                        )
                    }) }
                </ul>
            </div>
        ) : null
    }, [defaultBackground])

    return (
        <Grid
            container
            justifyContent='center'
            alignItems='center'
            sx={{
                height: '100%',
            } }
        >
            { slider }
            <Grid size={2.5} sx={{ zIndex: 2 }}>
                <Card>
                    <CardContent>
                        <Stack spacing={1} alignItems='center' justifyContent='center' sx={{ padding: '10px' }}>
                            { getPanel(token) }
                            <a href={ aquasysPath } target='_blank'>
                                <img src={ applicationFavicon || aquasysLogoPath } alt='' width='70px'/>
                            </a>
                            <Typography>{ template(i18n.signVersion)({ name: applicationNameSetting || applicationName, version: version || '' })}</Typography>
                            <a href='http://www.aquasys.fr' target='_blank'><b>{ i18n.aquasysCopyright }</b></a>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

export default ResetPasswordApp
